<table
  mat-table
  [dataSource]="_data"
  matSort
  (matSortChange)="$event ? sortData($event) : null"
  [id]="tableId"
  #myTable="matTable"
>
  <caption *ngIf="data?.caption">
    <div class="caption-content-wrapper flex flex-row">
      <span class="fill">{{ data?.caption }}</span>
      <div>
        <button mat-icon-button matTooltip="Download table"
          (click)="change.emit({ selected: true, value: data })"
          color="primary" *ngIf="!disableDownload">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button mat-icon-button color="primary" *ngIf="helper"
          (click)="helper(data.id)">
          <mat-icon>help</mat-icon>
        </button>
      </div>
    </div>
  </caption>
  <ng-container matColumnDef="select">
    <th class="row-select" mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="$event ? masterToggle() : null"
        [checked]="$any(selection.hasValue() && isAllSelected)"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
      ></mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="$event ? toggleRow(row) : null"
        [checked]="selection.isSelected(row)"
      ></mat-checkbox>
    </td>
  </ng-container>
  <ng-container *ngFor="let col of data?.header_row" [matColumnDef]="col.id">
    <th
      class="my-style default-styles"
      mat-header-cell
      *matHeaderCellDef
      [innerHTML]="col.value"
      [ngClass]="{ 'hide-me': col.hidden, highlight: col.highlight }"
      mat-sort-header
      [attr.colspan]="col.colspan || 1"
    ></th>
    <td
      class="my-style"
      [class.highlight]="col.highlight"
      mat-cell
      *matCellDef="let element"
    >
      <span
        *ngIf="col.id == 'label'; else other"
        [innerHTML]="element[col.id]"
      ></span>
      <ng-template #other>
        <span>{{ element[col.id] }}</span>
      </ng-template>
    </td>
  </ng-container>
  <ng-container matColumnDef="footerCol">
    <td
      mat-cell
      mat-footer-cell
      *matFooterCellDef="let element"
      [attr.colspan]="data.footer.col_span"
      class="my-style"
    >
      {{ data.footer.text }}
    </td>
  </ng-container>
  <tr
    mat-header-row
    *matHeaderRowDef="headerCols; sticky: true"
    [class.hide-me]="data?.hide_header_row"
    class="custom-row"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedCols"
    class="custom-row"
  ></tr>
  <ng-container *ngIf="data?.footer">
    <tr mat-footer-row *matFooterRowDef="['footerCol']"></tr>
  </ng-container>
</table>
